/**
 * AI Assistant MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { AI_QUICK_ACTIONS_QUERY_KEY, fetchQuickActionsFromApi } from "./aiAssistantQueryApi";

export const aiAssistantQueryClient = makeMv2QueryClient();

export function prefetchAiQuickActions() {
  return aiAssistantQueryClient.prefetchQuery({
    queryKey: [AI_QUICK_ACTIONS_QUERY_KEY],
    queryFn: ({ signal }) => fetchQuickActionsFromApi(signal),
  });
}
